/** sessionStorage key for agent email lead UUID (`inq_id` query param). */
export const INQ_ID_SESSION_STORAGE_KEY = 'inq_id';
